import { Component, OnInit } from '@angular/core';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { BaseAutorizeComponent } from 'src/app/shared/base-authorize.component';
import { AzureFunctionsService } from 'src/app/azurefunctions/azure-functions.service';

@Component({
  selector: 'app-testfiles',
  templateUrl: './testfiles.component.html',
  styleUrls: ['./testfiles.component.css']
})
export class TestfilesComponent extends BaseAutorizeComponent {

  settingsFilePath: string;
  editions: string;
  domain: string;
  targetClass: string;
  settingsFilePathValMessage: string;
  result: any;
  errors: string[];
  working: boolean;

  classes: string[] = ["DefaultUserModel", 
    "DefaultGroupModel", 
    "ApplicationConsentModel",
    "ResourceGroup",
    "ResourceProviderModel",
    "SubscriptionRoleModel"
  ];

  constructor(broadcastService: BroadcastService, authService: MsalService, private functionsService: AzureFunctionsService) { 
    super(broadcastService, authService)
    this.targetClass = this.classes[0];
  }

  onInitChild() {
    
  }

  onSettingsFilePathChanged = (value) => {
    this.settingsFilePath = value;
    if(!this.settingsFilePath){
      this.settingsFilePathValMessage = "Value can't be empty!";
    }
    else{
      this.settingsFilePathValMessage = "";
    }
  }

  onEditionsChanged = (value) => {
    this.editions = value;
  }

  onDomainChanged = (value) => {
    this.domain = value;
  }

  onTargetClassChanges = (value) => {
    this.targetClass = value;
  }

  doTest(){
    this.result = null;
    this.errors = null;
    this.working = true;
    if(!this.settingsFilePath){
      this.settingsFilePathValMessage = "Value can't be empty!";
      return;
    }
    var editions: string[] = [];
    if(this.editions){
      editions = this.editions.split(",");
      for (let i = 0; i < editions.length; i++) {
        editions[i] = editions[i].trim();
      }
    }
    this.functionsService.testFileMerging(this.settingsFilePath, this.targetClass, editions, this.domain).then(
      result => {
        this.result = result;
        this.working = false;
      },
      er => {
        if (er.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          this.errors = ['An error occurred:' + er.error.message ];
          
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(`Backend returned code ${er.status}, body was: ${er.error}`);
          if(er.error && er.error.errors)
            this.errors = er.error.errors;
          else
            this.errors = ['An unhandled error occurred:' + er.message ];
        }
        this.working = false;
      })

  }
}
